import type { Libraries } from '@react-google-maps/api'
import { useJsApiLoader } from '@react-google-maps/api'
import type { ReactNode } from 'react'
import { useContext, createContext } from 'react'

const init = { jsIsLoaded: false }
const googleMapsApiContext = createContext(init)
const libraries: Libraries = ['places']

interface IProvideGoogleMapsApi {
  children: ReactNode
}

export function ProvideGoogleMapsApi({ children }: IProvideGoogleMapsApi) {
  const initialState = useProvideGoogleMapsApi()

  return (
    <googleMapsApiContext.Provider value={initialState}>
      {children}
    </googleMapsApiContext.Provider>
  )
}

export const useGoogleMapsApi = () => {
  return useContext(googleMapsApiContext)
}

function useProvideGoogleMapsApi() {
  const { isLoaded: jsIsLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey:
      import.meta.env.VITE_GMAPS_API_KEY ?? 'no-google-maps-api-found',
    libraries,
  })

  return { jsIsLoaded }
}
